import {toast} from 'react-toastify';

let initialState = {
	infos: [],
	create: [],
	update: [],
	delete: [],
	ordre: []
};

const notifySuccess = (message) =>
	toast.success(message, {
		position: 'top-right',
		autoClose: 2000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined
	});

const notifyError = (message) =>
	toast.error(message, {
		position: 'top-right',
		autoClose: 3000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined
	});

const getMorceauxInfos = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_MORCEAUX_RETURN':
			return Object.assign({}, state, {infos: action.payload});

		case 'POST_MORCEAU_RETURN':
			let newStateAdd;
			if (action.payload?.status === 201) {
				newStateAdd = {...state.infos, data: (state.infos.data || []).concat([action.payload.data])};
				notifySuccess('Morceau ajouté !');
			} else {
				newStateAdd = state.infos;
				notifyError(action.payload?.data?.message || 'Erreur ! merci de le signaler...');
			}
			return Object.assign({}, state, {
				create: action.payload,
				infos: newStateAdd
			});

		case 'PUT_MORCEAU_RETURN':
			let newStateUpdate;
			if (action.payload?.status === 202) {
				const array = (state.infos.data || []).map((item) => {
					return item.uuid === action.payload.data.uuid ? action.payload.data : item;
				});
				newStateUpdate = {...state.infos, data: array};
				notifySuccess('Morceau mis à jour !');
			} else {
				newStateUpdate = state.infos;
				notifyError(action.payload?.data?.message || 'Erreur ! merci de le signaler...');
			}
			return Object.assign({}, state, {
				update: action.payload,
				infos: newStateUpdate
			});

		case 'PUT_MORCEAUX_ORDRE_SAGAS':
			// Reporte le nouvel ordre dans le store, sinon un rechargement de la liste réafficherait l'ancien
			const ordres = {};
			action.data.forEach((item) => (ordres[item.uuid] = item.ordre));
			const newStateOrdre = {
				...state.infos,
				data: (state.infos.data || []).map((item) => (ordres[item.uuid] !== undefined ? {...item, ordre: ordres[item.uuid]} : item))
			};
			return Object.assign({}, state, {infos: newStateOrdre});

		case 'PUT_MORCEAUX_ORDRE_RETURN':
			if (action.payload?.status === 202) {
				notifySuccess('Ordre de lecture mis à jour !');
			} else {
				notifyError('Erreur ! merci de le signaler...');
			}
			return Object.assign({}, state, {ordre: action.payload});

		case 'DEL_MORCEAU_SAGAS':
			const newStateDelete = {...state.infos, data: (state.infos.data || []).filter((item) => item.uuid !== action.payload)};
			return Object.assign({}, state, {infos: newStateDelete});

		case 'DEL_MORCEAU_RETURN':
			if (action.payload?.status === 202) {
				notifySuccess('Morceau supprimé !');
			} else {
				notifyError('Erreur ! merci de le signaler...');
			}
			return Object.assign({}, state, {delete: action.payload});

		default:
			return state;
	}
};

export default getMorceauxInfos;
